module.exports = __webpack_public_path__ + "static/media/our-team-member-2.4fe8ce24.png";